import apiFetch from '../apiFetch'

export default function (token, values) {
  return apiFetch({endPoint: `Albaran/getPoolsExtraccionAlbaran`, method: 'POST', body: values, token: token})
}